import { useEffect, useState } from 'react';
import { ProjectRepository } from '../../../features/project/data/projectRepository';

const useOptions = (load, deps) => {
  const [options, setOptions] = useState([]);
  useEffect(() => {
    let cancelled = false;
    Promise.resolve(load())
      .then((rows) => !cancelled && setOptions(rows))
      .catch(() => !cancelled && setOptions([]));
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return options;
};

export const useProjects = (accessToken) =>
  useOptions(() => ProjectRepository.listProjects({ accessToken }), [accessToken]);

// No project selected usually means no task list to show. Pass
// `includeAll=true` for screens that intentionally use the backend's all-task
// behavior.
export const useTasks = (projectId, accessToken, includeAll = false) =>
  useOptions(
    () => (projectId || includeAll ? ProjectRepository.listTasks({ projectId, accessToken }) : []),
    [projectId, accessToken, includeAll],
  );
